import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ERROR_STYLE } from 'lib/errors'
import { getLocale } from 'lib/utils/getLocale'

import ErrorMessageContent from './ErrorMessageContent'
import TranslatedAppError from 'components/Errors/TranslatedAppError'
import Button from 'components/UI/Button'
import Link from 'components/Link'
import AppContext from 'components/AppContext'

const DefaultErrorMessage = ({ appError }) => {
    const { t, i18n } = useTranslation(['errors'])

    const { type, code } = appError

    const defaultTitle = appError.style === ERROR_STYLE.ERROR ? t('errors:errorMessage.default.title') : ''
    const title = t(`errors:${type}.${code}.title`, defaultTitle)

    const fallbackDefaultError = (
        <TranslatedAppError appError={appError}>
            <AppContext context="defaultError">
                <p>
                    <Trans i18nKey="errors:errorMessage.default.content">
                        Palvelussa tapahtui valitettavasti tekninen virhe. Jos ongelma jatkuu, ota yhteyttä <Link to={`${getLocale(i18n.language)}/ota-yhteytta`} trackName="customerSupport">asiakaspalveluun</Link>.
                    </Trans>
                </p>
                <div style={{ marginTop: '.75rem' }}>
                    <span style={{ fontSize: '13px', fontWeight: '600' }}>{t('errors:errorMessage.default.tryThese.title')}</span>
                    <ul>
                        <li>
                            <Trans i18nKey="errors:errorMessage.default.tryThese.options.refreshPage">
                                Päivitä sivu <Button onClick={() => window.location.reload(true)} className="inline-button" trackName="optionReloadApp">tästä</Button>
                            </Trans>
                        </li>
                        <li>
                            {t('errors:errorMessage.default.tryThese.options.tryLater')}
                        </li>
                    </ul>
                </div>
            </AppContext>
        </TranslatedAppError>
    )

    return (
        <ErrorMessageContent
            title={title}
            content={fallbackDefaultError}
        />
    )
}

export default DefaultErrorMessage
